export default __webpack_public_path__ + "static/media/wegovy-outercap-remove.d2f4cb43.mp4";